export const stateEnum = (num) =>
	num === 1 ? "CORRECT" : num === 0 ? "KINDA" : "WRONG";

export const NEXT_WORD_HOUR = 6;

export const SERVER_URL = process.env.NODE_ENV !== "production" ? "" : "";
